import { Component, OnInit } from '@angular/core'
import { PrintService } from 'src/app/_shared/services/print.service'
import { OrderService } from '../../services/order.service'

@Component({
  selector: 'app-order-invoice',
  templateUrl: './order-invoice.component.html',
  styleUrls: ['./order-invoice.component.scss'],
})
export class OrderInvoiceComponent implements OnInit {
  date = new Date()
  constructor(
    public printService: PrintService,
    private orderService: OrderService
  ) {}

  ngOnInit() {
    this.printService.onDataReady()
  }

  public get orderData() {
    return this.orderService.currentOrder$.getValue()
  }

  public get outStandingBalance() {
    return this.grandTotal - this.totalAmountPaid
  }

  public get totalAmountPaid() {
    return this.orderData.amountPaid + (this.orderData.transportPaid || 0)
  }

  public get subTotal(): number {
    return this.orderData.order.reduce(
      (prev, curr) => prev + curr.price * curr.qty,
      0
    )
  }

  public get transportCost() {
    return parseFloat(
      (<unknown>(
        (this.orderData.transport_cost ||
          0)
      )) as string
    )
  }

  public get grandTotal(): number {
    return this.subTotal + this.transportCost
  }
}
